import {Component, Output, EventEmitter} from '@angular/core';
import {ClassesService} from '../../services/classes';
import {FiltersService} from '../../services/filters';

@Component({
  selector: 'app-date-selector',
  templateUrl: 'date-selector.html'
})
export class DateSelectorComponent {
  @Output() onDateSelected = new EventEmitter();
  dates = [];
  selectedDate = 0;
  today = new Date();
  lastCheckedDay = this.today;

  constructor(public classesService: ClassesService,
              public filtersService: FiltersService) {
  }

  ngOnInit() {
    this.initDatePicker()
    this.renewHeader()
  }

  renewHeader() {
    setInterval(() => {
      this.today = new Date();
      if (this.lastCheckedDay.getDate() !== this.today.getDate()) {
        this.classesService.initiateClasses()
        this.classesService.loadAll(
          true,
          this.filtersService.queryParams.touched ? this.filtersService.queryParams.structure.lower : null,
          this.filtersService.queryParams.touched ? this.filtersService.queryParams.structure.upper : null,
          this.filtersService.queryParams.latitude,
          this.filtersService.queryParams.longitude,
          this.filtersService.queryParams.radius,
          this.filtersService.queryParams.services,
          this.filtersService.queryParams.gym,
          this.filtersService.queryParams.city,
          this.filtersService.queryParams.zones,
          this.filtersService.queryParams.categories
        )
        this.initDatePicker()
      }
    }, 60 * 1000);
  }

  initDatePicker() {
    this.lastCheckedDay = this.today;
    this.dates = [];
    for (var i = 0; i <= 14; i++) {
      var tomorrow = new Date();
      tomorrow.setDate(this.today.getDate() + i)
      this.dates.push(tomorrow.toJSON())
    }
  }

  onSelect(i) {
    this.selectedDate = i;
    this.onDateSelected.emit({date: this.selectedDate})
  }

}



// WEBPACK FOOTER //
// ./src/components/date-selector/date-selector.ts